/**
 * Owner: Masa Bayu
 * File: qx-doc-title.ts
 * Date:Time: 2026-10-15 23:42
 * Description: Document title normalize · adopt first H1 when Untitled.
 */

import type { QXWDocument } from '@qx/qxw-core';
import type { OutlineNode } from './qx-draft-outline';

export function normalizeDocTitle(value: string): string {
  const trimmed = value.replace(/\s+/g, ' ').trim();
  return trimmed.length > 0 ? trimmed : 'Untitled';
}

export function withDocTitle(doc: QXWDocument, title: string): QXWDocument {
  const next = normalizeDocTitle(title);
  if (doc.metadata.title === next) return doc;
  return {
    ...doc,
    metadata: {
      ...doc.metadata,
      title: next,
      updatedAt: new Date().toISOString(),
    },
  };
}

/** When tip title is still Untitled, adopt first Outline H1 label. */
export function adoptTitleFromOutline(
  doc: QXWDocument,
  nodes: readonly OutlineNode[],
): QXWDocument {
  const current = (doc.metadata.title ?? '').trim();
  if (current.length > 0 && current !== 'Untitled') return doc;
  const first = nodes[0]?.label?.trim();
  if (!first) return doc;
  return withDocTitle(doc, first);
}
